import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FileElement } from '../model/file-element';

@Injectable({
  providedIn: 'root'
})
export class FileExplorerService implements IFileService{
  private map = new Map<string, FileElement>();
  private querySubject: BehaviorSubject<FileElement[]>;
  currentPath="Files";
  currentRoot: FileElement;

  constructor() { }

  add(fileElement: FileElement) {
    fileElement.id = this.Uuid();
    this.map.set(fileElement.id, this.clone(fileElement))
    return fileElement
  }
  
  

  delete(id: string) {
    this.map.delete(id);
  }
  queryInFolder(folderId: string): Observable<FileElement[]> {
    const result: FileElement[] = [];
    this.map.forEach(element => {
      if (element.parent === folderId) {
        result.push(this.clone(element));
      }
    });
    if (!this.querySubject) {
      this.querySubject = new BehaviorSubject(result);
    } else {
      this.querySubject.next(result);
    }
    return this.querySubject.asObservable();
  }
  get(id: string): FileElement {
    return this.map.get(id);
  }
  clone(element: FileElement): FileElement {
    return JSON.parse(JSON.stringify(element));
  }
  clearMap()
  {
    this.map.clear();
  }

  deleteElements(keys:string[])
  {
    for (var key of keys)
    {
      this.map.delete(key);
    }
  }
  getElementsSize():number
  {
    return this.map.size;
  }

  getCurrentPath(){
    //console.log("Get Current Path ",this.currentPath)
    return this.currentPath;
  }
  setCurrentPath(currPath:string){
    //console.log("Set Current Path ",currPath);
    this.currentPath=currPath;
    //console.log("After Set Current Path ",this.currentPath);
  }

  setCurrentRoot(currRoot: FileElement){
    this.currentRoot=currRoot;
  }

  getCurrentRoot(){
    return this.currentRoot;
  }


  Uuid() {
    const windowObj: any = window;
    const winCrypto = windowObj.crypto || windowObj.msCrypto;
    let index = winCrypto.getRandomValues(new Uint32Array(1))[0];
    index = +`${index}`.substr(0, 1);
    const uuid = winCrypto.getRandomValues(new Uint32Array(10))[index];
    return uuid;
  }
}

export interface IFileService {
  add(fileElement: FileElement):any
  delete(id: string):any
  queryInFolder(folderId: string): Observable<FileElement[]>
  get(id: string): FileElement
}


